import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE, replace } from 'react-router-redux';
import moment from 'moment';
import qs from 'qs';

import map from 'lodash/map';
import capitalize from 'lodash/capitalize';
import cloneDeep from 'lodash/cloneDeep';
import values from 'lodash/values';
import countBy from 'lodash/countBy';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import includes from 'lodash/includes';
import _findIndex from 'lodash/findIndex';

import http from '../../shared/http';
import intl from '../../shared/intl';
import endpoints from '../../../config/endpoints';
import { create as paginationCreate } from '../../shared/pagination';
import { calculateGeoGoals } from '../shared';
import { enum as affiliateLevels } from '../../../../../enums/affiliate-levels';

import { REFETCH_ALL_DATA, actions as rootActions } from '../../root';

const isRocket = process.env.CPA_ENV === 'rocket';

const pagination = paginationCreate('offers', {
	OffersTable: {
		currentPage: 1,
		perPage: 50
	}
});

const OFFERS_FETCH_DATA = 'offers/fetch-data-success';
const OFFERS_FETCH_ERROR = 'offers/fetch-data-error';

const OFFERS_FETCH_ACTIVE_OK = 'offers/OFFERS_FETCH_ACTIVE_OK';
const OFFERS_FETCH_ACTIVE_NOT_OK = 'offers/OFFERS_FETCH_ACTIVE_NOT_OK';

const FILTER_BY_CATEGORY = 'offers/filter-by-category';
const APPLY_FILTERS = 'offers/apply-filters';
const RESET_FILTERS = 'offers/reset-filters';
const SHOW_PROGRESS_BAR = 'offers/show-progress-bar';

const OFFER_ADD_SUCCESS = 'offers/add-offer-success';
const OFFER_ADD_ERROR = 'offers/add-offer-error';

const BOOST_SUCCESS = 'offers/boost-success';
const BOOST_ERROR = 'offers/boost-error';

const TOGGLE_RULES = 'offers/toggle-rules';
const ADD_AFFILIATES_TO_SWITCH = 'offers/add-affiliates-to-switch';

const TOGGLE_UNCLICKABLE_LINK = 'offers/toggle-uncklickable-link';

const initialState = {
	data: null,
	activeOfferData: null,
	error: null,
	progressBar: false,
	tableId: 1,
	shouldShowUserOffers: false,
	shouldShowRules: false,
	offerIdForModalRules: null,
	clickedBoostLocation: null,
	shouldShowChildOffers: false,
	filters: {
		offersSearch: '',
		category: [],
		geo: [],
		offer: [],
		currency: [],
		childAffiliates: [],
		isNew: false,
		isExclusive: false,
		isOwnCallcenter: false,
		isContestEnabled: false
	},
	switchControlsConfig: [
		{
			className: '',
			title: 'Все',
			url: 'offers/public/'
		},
		{
			className: '',
			title: 'Мои',
			url: 'offers/my/'
		}
	],
	pagination: pagination.initState,
	columns: {
		offer: {
			id: 'offer',
			direction: 'desc',
			position: 'title',
			title: 'Оффер'
		},
		cr: {
			id: 'cr',
			direction: 'desc',
			position: 'cr',
			title: 'CR'
		},
		approve: {
			id: 'approve',
			direction: 'desc',
			position: 'approve',
			title: 'Под.'
		}
	}
};

export const actions = {
	fetchData: (props, search) => (dispatch, getState) => {
		const user = getState().app.userData.general;
		const request = http({
			url: [`${endpoints.OFFERS.LIST}?search=${search || ''}`],
			method: 'get',
			actions: [OFFERS_FETCH_DATA, OFFERS_FETCH_ERROR]
		});

		const activeOfferGeos = http({
			url: endpoints.OFFERS.ACTIVE,
			method: 'get',
			actions: [OFFERS_FETCH_ACTIVE_OK, OFFERS_FETCH_ACTIVE_NOT_OK]
		});
		if (!user.is_master && props && props.location && props.location.pathname === '/offers/affiliates/') {
			return dispatch(replace('/offers/public/'));
		}
		request(dispatch).then(async action => {
			if (action.type === OFFERS_FETCH_DATA) {
				if (process.env.CPA_ENV === 'everad') {
					await dispatch(activeOfferGeos);
				}
				const externalQuery = getExternalQuery();

				user.is_master && dispatch({ type: ADD_AFFILIATES_TO_SWITCH });

				if (!isEmpty(externalQuery)) {
					if (externalQuery.category) {
						dispatch(actions.filterByCategory(externalQuery.category.id));
					}

					if (externalQuery.geo) {
						dispatch(actions.filterByGeo(externalQuery.geo.map((g) => +g)));
					}

					if (externalQuery.offer) {
						dispatch(actions.filterByOfferId(externalQuery.offer.map((id) => +id)));
					}

					dispatch(replace(window.location.pathname));
				}
			}
		});
	},

	addOffer: id => (dispatch, getState) => {
		const request = http({
			url: `${endpoints.OFFERS.LIST}/${id}/request`,
			method: 'get',
			addToResponse: {
				offerIdForModalRules: getState().offers.offerIdForModalRules,
				clickedBoostLocation: getState().offers.clickedBoostLocation
			},
			actions: [OFFER_ADD_SUCCESS, OFFER_ADD_ERROR]
		});

		dispatch({ type: SHOW_PROGRESS_BAR });
		if (!getState().offers.clickedBoostLocation) {
			request(dispatch);
		} else {
			request(dispatch).then(action => {
				if (action.type === OFFER_ADD_SUCCESS) {
					dispatch(actions.boost(
						action.meta.offerIdForModalRules,
						action.meta.clickedBoostLocation
					));
				}
			});
		}
	},

	toggleRules: (offerId, clickedLocation) => ({
		type: TOGGLE_RULES,
		payload: {offerId, clickedLocation}
	}),

	pagination: () => dispatch => pagination.actions(dispatch),

	filterByCategory: category => (dispatch, getState) => {
		const categoryList = getState().app.lists['offer-categories'];
		dispatch({
			type: FILTER_BY_CATEGORY,
			payload: { category, categoryList }
		});
	},

	filterByGeo: geo => (dispatch, getState) => {
		const data = getState().offers.data;
		const geoOptions = data && getGeoOptions(data);

		dispatch(actions.setFilters({
			geo: geoOptions.filter((o) => includes(geo, o.value)).map((o) => ({
				...o,
				className: `flag-icon-${o.countryCode.toLowerCase()} flag-positioning`
			}))
		}));
	},

	filterByOfferId: offer => (dispatch, getState) => {
		dispatch(actions.setFilters({ offer }));
	},

	setFilters: filters => (dispatch, getState) => {
		dispatch({
			type: APPLY_FILTERS,
			payload: {
				...getState().offers.filters,
				...filters
			}
		});
	},

	applyFilters: filters => dispatch => {
		dispatch({
			type: APPLY_FILTERS,
			payload: filters
		});
		dispatch(actions.fetchData(null, filters.offersSearch));
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	},

	resetFilters: () => dispatch => {
		dispatch(replace(window.location.pathname));
		dispatch({
			type: RESET_FILTERS
		});
	},

	setUnClickableLink: offer_id => ({
		type: TOGGLE_UNCLICKABLE_LINK,
		payload: offer_id
	}),

	boost: (offerId, clickedLocation) => (dispatch, getState) => {
		const request = http({
			url: `${endpoints.OFFERS.LIST}/${offerId}/boost`,
			method: 'put',
			data: { clickedLocation },
			addToResponse: {
				offerId, clickedLocation
			},
			actions: [BOOST_SUCCESS, BOOST_ERROR]
		});

		dispatch(rootActions.spinnerToggle());
		request(dispatch).then(() => dispatch(rootActions.spinnerToggle()));
	}
};

const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			const path = action.payload.pathname;
			const externalQuery = getExternalQuery();

			return {
				...state,
				data: path.indexOf('offers/') == -1 || !isEmpty(externalQuery) ? null : state.data,
				filters: path.indexOf('offers/') == -1 || !isEmpty(externalQuery) ? initialState.filters : state.filters,
				shouldShowUserOffers: path.indexOf('offers/my/') !== -1,
				shouldShowRules: path.indexOf('offers/') == -1,
				shouldShowChildOffers: path.indexOf('offers/affiliates/') !== -1
			};
		},
		[OFFERS_FETCH_ACTIVE_OK]: (state, action) => {
			return { ...state, activeOfferData: action.payload.data };
		},
		[OFFERS_FETCH_DATA]: (state, action) => {
			const [data] = map(action.payload, res => res.data);
			return { ...state, data };
		},
		[OFFERS_FETCH_ERROR]: (state, action) => {
			return { ...state, error: true };
		},

		[FILTER_BY_CATEGORY]: (state, action) => {
			const category = !isRocket ? action.payload.category : Number(action.payload.category);
			let newCategory = find(action.payload.categoryList, { id: category });
			newCategory = { value: newCategory.id, label: capitalize(newCategory.text) };

			// perf improvement, avoid unnecessary rerenders on double click
			// issue due to animation - see tableId++ below
			if (find(state.filters.category, newCategory)) {
				return { ...state };
			}

			return {
				...state,
				filters: {
					...state.filters,
					category: state.filters.category.filter(cat => cat.value !== category).concat(newCategory)
				},
				rowsNumber: initialState.rowsNumber,
				tableId: (state.tableId += initialState.tableId)
			};
		},

		[APPLY_FILTERS]: (state, action) => {
			return {
				...state,
				filters: action.payload,
				tableId: (state.tableId += initialState.tableId)
			};
		},

		[RESET_FILTERS]: (state, action) => {
			return {
				...state,
				data: null,
				filters: initialState.filters
			};
		},

		[REFETCH_ALL_DATA]: () => initialState,

		[TOGGLE_UNCLICKABLE_LINK]: (state, action) => {
			const newData = [...state.data];
			const uncklickableOfferIndex =  _findIndex(newData, i => i.id === action.payload);
			newData[uncklickableOfferIndex].uncklickable_link = !newData[uncklickableOfferIndex].uncklickable_link;
			return {
				...state,
				data: newData
			};
		},

		[OFFER_ADD_SUCCESS]: () => {
			return initialState;
		},
		[OFFER_ADD_ERROR]: state => {
			return { ...state, error: true, progressBar: false };
		},
		[SHOW_PROGRESS_BAR]: state => {
			return { ...state, progressBar: true };
		},
		[TOGGLE_RULES]: (state, action) => {
			return {
				...state,
				shouldShowRules: !state.shouldShowRules,
				offerIdForModalRules: state.shouldShowRules ? null : action.payload.offerId,
				clickedBoostLocation: state.clickedBoostLocation ? null : action.payload.clickedLocation
			};
		},
		[BOOST_SUCCESS]: (state, action) => {

			const offers = state.data.map(offer => {
				if (offer.id === action.meta.offerId) {
					offer.payouts = offer.payouts.map(payout => {
						if (payout.location_id === action.meta.clickedLocation) {
							const currentLocationOffer = offer.locations.find(elem => elem.id === action.meta.clickedLocation);
							payout.amount = Math.round(payout.amount * (1 + Number(currentLocationOffer.boost_value)));
							payout.boost_till = moment().add(7, 'days').format('YYYY-MM-DD HH:mm:ss');
						}
						return payout;
					});
				}
				return offer;
			});

			return {
				...state,
				data: offers
			};
		},
		[BOOST_ERROR]: (state, action) => {
			return { ...state, error: true, progressBar: false };
		},
		[ADD_AFFILIATES_TO_SWITCH]: state => ({
			...state,
			switchControlsConfig: [
				...initialState.switchControlsConfig,
				{
					className: '',
					title: 'Вебмастеров',
					url: 'offers/affiliates/'
				}
			]
		})
	},
	pagination.reducers
);

export default handleActions(reducers, cloneDeep(initialState));

export const selectors = {
	getData: state => state.offers.data,
	getActiveOfferData: state => state.offers.activeOfferData,
	getManagerData: state => state.managerPopup.manager,
	getTableData: state =>
		pagination.selectors.getPageData(
			state => state.offers.data && filterUserOffers(
				getTableRows(state),
				state.offers.shouldShowUserOffers,
				state.offers.shouldShowChildOffers
			),
			state => state.offers.pagination.OffersTable.perPage,
			state => state.offers.pagination.OffersTable.currentPage
		)(state),
	getTableHeaders: state => values(state.offers.columns),
	getRowsCount: state => getRowsCount(getTableRows(state)),
	getSwitchControlsConfig: state => {
		const rowsCount = selectors.getRowsCount(state);
		return map(state.offers.switchControlsConfig, (item, i) => {
			if (i === 0) {
				item['secondTitle'] = rowsCount.all;
			} else if (i == 1) {
				item['secondTitle'] = rowsCount.userOffers;
			} else if (i === 2) {
				item['secondTitle'] = rowsCount.childOffers;
			}
			return item;
		});
	},
	getColumnSorting: state => state.offers.columnSorting,
	getTableId: state => state.offers.tableId,
	getFormData: state => ({
		initialValue: state.offers.filters,
		categoryOptions: state.app.lists && getListOptions(state.app.lists, 'offer-categories'),
		geoOptions: state.offers.data && getGeoOptions(state.offers.data),
		currenciesOptions: state.app.userData.balances && getCurrenciesOptions(state.app.userData.balances),
		childAffiliatesOptions: state.app.userData.general.is_master && getChildAffiliatesOptions(state.offers.data)
	}),
	getIsUserMaster: state => state.app.userData.general.is_master,
	getIntl: state => intl(state),
	getLists: state => state.app.lists,
	getError: state => state.offers.error,
	getUser: state => state.app.userData && state.app.userData.general,
	getAffiliateLevels: () => affiliateLevels,
	getOfferInfo: state => {
		const offer = find(state.offers.data, { id: state.offers.offerIdForModalRules });
		if (!offer) {
			return state;
		}
		return {
			shouldShowRules: state.offers.shouldShowRules,
			offerTitle: offer.title,
			offerId: offer.id,
			offerRules: offer.rules,
			offerAvailability: offer.available,
			offerAccessThreadId: offer.offer_access_thread_id,
			offerAccessOnRequest: offer.access_on_request
		};
	},
	getShouldShowBoostBanner: state => {
		const data = state.offers.data;

		if (!data) return false;

		return  data.some(entity => {
			return entity.goals && !!(entity.goals.some(g => g.isBoosterAvailable));
		});
	}
};

const getTableRows = state => {
	let data = state.offers.data && map(state.offers.data, offer => calculateGeoGoals(offer, false));
	const filteredRows = filterRows(data, state.offers.filters, state.app.userData);
	return filteredRows;
};

const filterUserOffers = (rows, shouldFilterByUserOffers, shouldFilterByChildOffers) => {
	if (!shouldFilterByUserOffers && !shouldFilterByChildOffers) {
		return rows;
	} else if (shouldFilterByUserOffers) {
		return rows.filter(row => row.available);
	} else if (shouldFilterByChildOffers) {
		return rows.filter(row => !!row.child_affiliates);
	}
};

const filterRows = (rows, filters, user) => {
	return (
		rows &&
		rows.filter(row => {
			const hasCategory = !filters.category.length ||
				find(filters.category, { value: !isRocket ? row.category : row.category_id });
			const hasGeo =
				!filters.geo.length ||
				map(row.locations, location => find(filters.geo, { value: location.id })).filter(val => !!val).length;

			const hasOfferId = !filters.offer.length || includes(filters.offer, row.id);

			const hasCurrency =
				!filters.currency.length ||
				map(row.payouts, payout => find(filters.currency, { value: payout.currency })).filter(val => !!val).length;

			const isNew = !filters.isNew || (filters.isNew && row.is_new);
			const isExclusive = !filters.isExclusive || (filters.isExclusive && row.is_exclusive);
			const isContestEnabled =
				!filters.isContestEnabled ||
				(filters.isContestEnabled &&
				row.locations &&
				row.locations.filter(location => location.is_contest_enabled).length);
			const isOwnCallcenter =
				!filters.isOwnCallcenter ||
				(filters.isOwnCallcenter &&
				row.locations &&
				row.locations.filter(location =>  location.is_own_callcenter).length);

			const hasChildAffiliates =
				!filters.childAffiliates.length ||
				map(row.child_affiliates, aff => find(filters.childAffiliates, { value: aff.id })).filter(val => !!val).length;

			return (
				hasCategory &&
				isNew &&
				isContestEnabled &&
				isExclusive &&
				isOwnCallcenter &&
				hasGeo &&
				hasOfferId &&
				hasCurrency &&
				hasChildAffiliates
			);
		})
	);
};

const getRowsCount = rows => {
	let result = countBy(rows, row => row.available);
	return {
		userOffers: result.true || 0,
		all: rows && rows.length,
		childOffers: countBy(rows, row => !!row.child_affiliates).true || 0
	};
};

const getListOptions = (lists, key) => {
	return lists[key].map(item => ({
		label: capitalize(item.text),
		value: item.id
	}));
};

const getGeoOptions = rows => {
	return (
		rows &&
		rows.reduce((accumulator, current) => {
			current.locations &&
			current.locations.forEach(location => {
				if (!find(accumulator, { value: location.id })) {
					accumulator.push({
						value: location.id,
						label: location.name,
						countryCode: location['country_code']
					});
				}
			});
			return accumulator;
		}, [])
	);
};

const getChildAffiliatesOptions = rows => {
	return (
		rows &&
		rows.reduce((accumulator, current) => {
			current.child_affiliates &&
				current.child_affiliates.forEach(affiliate => {
					if (!find(accumulator, { value: affiliate.id })) {
						accumulator.push({
							value: affiliate.id,
							label: affiliate.email
						});
					}
				});
			return accumulator;
		}, [])
	);
};

const getCurrenciesOptions = rows => {
	return rows.map(item => ({
		label: capitalize(item.currency),
		value: item.currency
	}));
};

const getExternalQuery = () => {
	const externalQueryString = window.location.search.slice(1);
	return qs.parse(externalQueryString);
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/list/index.js